import type { ListCollection } from '@chakra-ui/react';
import React from 'react';

import { Button } from 'toolkit/chakra/button';
import type { SelectOption } from 'toolkit/chakra/select';
import { SelectContent, SelectItem, SelectRoot, SelectControl } from 'toolkit/chakra/select';
import { Skeleton } from 'toolkit/chakra/skeleton';

import IconSvg from '../IconSvg';

interface Props {
  name: string;
  collection: ListCollection<SelectOption>;
  initialValue?: string;
  isLoading?: boolean;
  onChange: (nextValue: string) => void;
}

const PopoverFilterRadio = ({ name, collection, onChange, initialValue, isLoading }: Props) => {

  const handleValueChange = React.useCallback(({ value }: { value: Array<string> }) => {
    onChange(value[0]);
  }, [ onChange ]);

  if (isLoading) {
    return <Skeleton loading w={{ base: 9, lg: '78px' }} h={ 8 } borderRadius="base" flexShrink={ 0 }/>;
  }

  return (
    <SelectRoot
      name={ name }
      collection={ collection }
      defaultValue={ initialValue ? [ initialValue ] : [ collection.items[0].value ] }
      onValueChange={ handleValueChange }
      w="fit-content"
      variant="plain"
    >
      <SelectControl
        triggerProps={{ asChild: true, px: { base: 1, lg: 2 } }}
        noIndicator
        defaultValue={ [ collection.items[0].value ] }
      >
        <Button
          fontWeight="medium"
          gap="6px"
          variant="dropdown"
          fontStyle="text.sm"
          flexShrink={ 0 }
          pointerEvents="all"
          px={{ base: 1, lg: 3 }}
        >
          Filter
          <IconSvg
            _groupExpanded={{ transform: 'rotate(180deg)' }}
            name="arrows/down"
            boxSize={ 5 }
          />
        </Button>
      </SelectControl>
      <SelectContent>
        { collection.items.map((item) => (
          <SelectItem item={ item } key={ item.value }>
            { item.label }
          </SelectItem>
        )) }
      </SelectContent>
    </SelectRoot>
  );
};

export default React.memo(PopoverFilterRadio);
